// Typed error for the DDL edit applicator (`applyDdlEdit`).
//
// PRD: Ralph/DdlStructuralEdit2/PRD.md § DSE2-6 — "Engines that genuinely
// don't support an op … return an `EngineDoesNotSupportOp` error from
// `applyDdlEdit`; consumers handle the error rather than silently degrading."
//
// `DdlEditError` is the concrete realisation of that contract (the
// "EngineDoesNotSupportOp" name only ever existed in JSDoc). The `code`
// discriminant lets consumers (Table Designer, VqeDdlEdit, `resolveDdlEdit`)
// distinguish a genuine engine-capability gap from a malformed edit without
// fragile message string-matching:
//
//   - 'engine-does-not-support-op' — the engine genuinely lacks the op or a
//     requested capability (e.g. sqlite has no ALTER COLUMN; mysql/oracle
//     have no partial-index WHERE clause; sqlite has no CREATE DATABASE). The
//     consumer should surface a loud, actionable failure (the message carries
//     the dialect-specific workaround hint) rather than silently degrading.
//   - 'invalid-edit' — the edit itself is malformed / under-specified (e.g.
//     an empty `change` object, a CHECK with no expression). This is a caller
//     bug, NOT an engine-capability gap, and must never be conflated with the
//     unsupported-op contract above.
//
// Mirrors the sanctioned `EmitSourceError` shape (`src/features/sql-resolver/
// edit/emitSource.ts`) — the codebase's documented exception to the
// no-class rule: a typed error MUST subclass `Error`, with a `readonly code`
// string-literal-union discriminant (no `enum`).

export type DdlEditErrorCode =
  | 'engine-does-not-support-op'
  | 'invalid-edit';

export class DdlEditError extends Error {
  readonly code: DdlEditErrorCode;
  constructor(code: DdlEditErrorCode, message: string) {
    super(message);
    this.name = 'DdlEditError';
    this.code = code;
  }
}
